module.exports = __webpack_public_path__ + "static/media/15.5d389621.png";